<div class="side-bar  bottom-0 start-0 z-index py-3 z-2 px-2 top-90 col-lg-2" [class.hide]="!showSidebar">
  <!--main navigation-->

  <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="/dashboard"   [routerLinkActiveOptions]="{ exact: true }">
      <img src="./navigation/dashboard.svg"> Dashboard
  </a>
<!--
  <a tabindex="1"  class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="users">
      <img src="./navigation/users.svg"> Users
  </a>
  <a tabindex="1"  class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="owner">
      <img src="./navigation/owner 2.svg"> Owners
  </a> -->
  <!-- <a tabindex="1"  class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="payment">
      <img src="./navigation/payments.svg"> Payments
  </a> -->
  <a tabindex="1"  class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="/manage-subscription">
      <img src="./navigation/CrownSimple.svg"> Manage Subscription
  </a>
  <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="/transactions">
      <img src="./navigation/scan.svg"> Transaction
  </a>
  <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="/members">
    <img src="./navigation/UsersFour.svg"> Members
</a>


  <a tabindex="1"  class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active"   :routerLink="/invite-friends">
      <img src="./navigation/UserPlus.svg"> Invite Friends
  </a>
  <a tabindex="1"  class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active"   :routerLink="/activities">
    <img src="./navigation/note-favorite.svg"> Activity
</a>
  <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="#">
    <img src="./navigation/stats.svg"> Statistics
</a>
<a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="financial">
  <img src="./community/financialIcon.svg"> Financial
</a>
<a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="/users">
  <img src="usersSide.svg"> Manage Users
</a>
<a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="/cancellation-request">
  <img src="cancellation.svg"> Cancellation
</a>
<a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="/appointment-list">
  <img src="/appointment/Calender.svg"> Appointments Bookings
</a>



  <div style="margin-top:124px">
      <span class="other gray mb-3 fw-bold mt-4 d-block">other</span>
      <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1">
          <img src="./navigation/help.svg"> Help
      </a>

          <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" [routerLink]="['/settings']" routerLinkActive="active">
              <img src="./navigation/setting.svg"> Settings
          </a>
      <!-- <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" style="cursor: pointer" (click)="logoutCall()">
          <img src="./navigation/logout.svg"> Logout
      </a> -->
      <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" style="cursor: pointer" (click)="logoutModal()">
        <img src="./navigation/logout.svg"> Logout
    </a>

  </div>
</div>

<!-- sidebar-menu  -->


<div class="modal" tabindex="-1" role="dialog"  [ngStyle]="{'display':display}">
<div class="modal-dialog modal-dialog-centered" role="document" style="width: 400px;">
      <div class="modal-content">
            <div class="modal-header pb-0 mb-0 d-flex justify-content-end">
              <button type="button" class="close border-0" aria-label="Close" #closebutton (click)="onCloseHandled()">
                <img src="./close2.svg" alt="">
              </button>
                </div>
         <div class="modal-body text-center my-0 py-0">
                <span><img src="./community/logout.svg" alt=""></span>
                <h5>Logout</h5>
                <p class="text-muted ">Are you sure you want to logout? </p>
          </div>
                <div class="modal-footer text-center mx-auto mt-0 pt-0 mb-2">
                  <button type="button" class="btn btn-delete mx-2" data-bs-dismiss="modal" (click)="onCloseHandled()">Cancel</button>
                  <button type="button" class="btn btn-color mx-2" id="closeModal" (click)="onSubmitModal2()" >Logout</button>
                </div>
   </div>
    </div>
</div>
